import { render, staticRenderFns } from "./BaseInfoForm.vue?vue&type=template&id=56427eb0&scoped=true"
import script from "./BaseInfoForm.vue?vue&type=script&lang=js"
export * from "./BaseInfoForm.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoForm.vue?vue&type=style&index=0&id=56427eb0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56427eb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56427eb0')) {
      api.createRecord('56427eb0', component.options)
    } else {
      api.reload('56427eb0', component.options)
    }
    module.hot.accept("./BaseInfoForm.vue?vue&type=template&id=56427eb0&scoped=true", function () {
      api.rerender('56427eb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/goodsList/components/BaseInfoForm.vue"
export default component.exports